import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i3 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import * as i1$1 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import * as i2 from 'reference-library';
import * as i4 from '@angular/router';
import * as i5 from 'app-services-library';
import * as i7 from '@angular/common';
import * as i8 from 'primeng/checkbox';
import { PrimengLibraryModule } from 'primeng-library';

class CustomCheckboxService {
    constructor(http) {
        this.http = http;
        this.formValues = {};
    }
    setFormValue(formControlName, value) {
        this.formValues[formControlName] = value;
    }
    getFormValue(formControlName) {
        return this.formValues[formControlName];
    }
    clearFormValue(formControlName) {
        delete this.formValues[formControlName];
    }
}
CustomCheckboxService.ɵfac = function CustomCheckboxService_Factory(t) { return new (t || CustomCheckboxService)(i0.ɵɵinject(i1.HttpClient)); };
CustomCheckboxService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomCheckboxService, factory: CustomCheckboxService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomCheckboxService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CustomCheckboxComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelement(3, "p-checkbox", 8);
    i0.ɵɵelementStart(4, "label", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const x_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", x_r4.value.name)("value", x_r4.value.isChecked)("formControl", x_r4.controls["isChecked"])("binary", true);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("for", x_r4.value.isChecked);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(x_r4.value.name);
} }
function CustomCheckboxComponent_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomCheckboxComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, CustomCheckboxComponent_div_1_ng_container_4_Template, 6, 7, "ng-container", 4);
    i0.ɵɵtemplate(5, CustomCheckboxComponent_div_1_span_5_Template, 2, 0, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formArrayName", ctx_r0.formArrayNameForThis);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.getCheckboxArray);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r0.inputParams == null ? null : ctx_r0.inputParams.mandatory) && ctx_r0.group.get(ctx_r0.inputParams.name).touched && ctx_r0.group.get(ctx_r0.inputParams.name).hasError("requiredArray"));
} }
function CustomCheckboxComponent_div_2_em_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomCheckboxComponent_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "p-checkbox", 15);
    i0.ɵɵlistener("ngModelChange", function CustomCheckboxComponent_div_2_ng_container_3_Template_p_checkbox_ngModelChange_3_listener($event) { const x_r9 = ctx.$implicit; return x_r9.value.isChecked = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const x_r9 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("binary", true)("value", x_r9.value.isChecked)("ngModel", x_r9.value.isChecked)("formControl", x_r9.controls["isChecked"]);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("for", x_r9.value.isChecked);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(x_r9.value.name);
} }
function CustomCheckboxComponent_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomCheckboxComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵtemplate(2, CustomCheckboxComponent_div_2_em_2_Template, 2, 0, "em", 12);
    i0.ɵɵtemplate(3, CustomCheckboxComponent_div_2_ng_container_3_Template, 6, 6, "ng-container", 4);
    i0.ɵɵtemplate(4, CustomCheckboxComponent_div_2_span_4_Template, 2, 0, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formArrayName", ctx_r1.formArrayNameForThis);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.getCheckboxArray);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory) && ctx_r1.group.get(ctx_r1.inputParams.name).touched && ctx_r1.group.get(ctx_r1.inputParams.name).hasError("requiredArray"));
} }
const _c0 = function (a0) { return { "width": a0 }; };
class CustomCheckboxComponent {
    constructor(fb, referenceLibraryService, store, cdRef, route, appServicesLibraryService, customCheckboxService) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        this.store = store;
        this.cdRef = cdRef;
        this.route = route;
        this.appServicesLibraryService = appServicesLibraryService;
        this.customCheckboxService = customCheckboxService;
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        this.formArrayNameForThis = this.inputParams.name;
        this.userType = sessionStorage.getItem('userTypeRole');
        const checkBoxValidators = this.inputParams.mandatory ? [this.requiredArrayValidator] : [];
        this.group.addControl(this.inputParams.name, this.fb.array([], checkBoxValidators));
        if (this.inputParams && this.inputParams.properties && this.inputParams.properties.isDataFromApi && this.inputParams.properties.refercenceCodeForApiCall != '') {
            this.referenceLibraryService.getDataSource(this.inputParams.properties.refercenceCodeForApiCall, '').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                var _a, _b, _c;
                this.refDataArr = response.map(x => {
                    return Object.assign(Object.assign({}, x), { isChecked: false });
                });
                if (((_a = this.refDataArr) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    if (((_b = this.inputParams.properties.inputArray) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        this.inputParams.properties.inputArray = [];
                    }
                    if (((_c = this.inputParams.value) === null || _c === void 0 ? void 0 : _c.length) > 0 && !(this.arraysHaveSameLengthAndProperty(JSON.parse(JSON.stringify(this.refDataArr)), JSON.parse(JSON.stringify(this.inputParams.value)), 'name'))) {
                        this.inputParams.value = [];
                    }
                }
                this.addArrayFormControl();
            });
        }
        else {
            this.refDataArr = [];
            if (this.inputParams.value && this.inputParams.value.length > 0) {
                this.group.controls[this.inputParams.name].clear();
                this.inputParams.value.forEach((x, index) => {
                    const formGroup = this.createCustomArrayList(x);
                    this.group.get([this.inputParams.name]).push(formGroup);
                });
            }
            // this.cdRef.detectChanges();
        }
        /* Retreive selected values while navigating between step - multi step form */
        this.route.queryParams.subscribe(params => {
            const stepParameter = params['step'];
            if (!stepParameter) {
                this.customCheckboxService.clearFormValue(this.inputParams.name);
            }
            else {
                this.savedValue = this.customCheckboxService.getFormValue(this.formControlName);
                if (this.savedValue) {
                    this.addArrayFormControl();
                }
            }
        });
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleInputFields();
            });
            // this.cdRef.detectChanges();
        }
        this.group.get(this.inputParams.name).valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(values => {
            this.customCheckboxService.setFormValue(this.inputParams.name, values);
        });
    }
    arraysHaveSameLengthAndProperty(arr1, arr2, propertyName) {
        if (arr1.length !== arr2.length) {
            return false; // Check if the arrays have the same length
        }
        // Sort both arrays by the property you want to compare
        arr1.sort((a, b) => a[propertyName].localeCompare(b[propertyName]));
        arr2.sort((a, b) => a[propertyName].localeCompare(b[propertyName]));
        // Compare the sorted arrays element by element
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i][propertyName] !== arr2[i][propertyName]) {
                return false; // Return false if any elements differ
            }
        }
        return true; // If all elements are the same, return true
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    addArrayFormControl() {
        var _a, _b;
        if (((_a = this.inputParams.value) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.group.controls[this.inputParams.name].clear();
            this.inputParams.value.forEach((x, index) => {
                const formGroup = this.createArrayList(x);
                this.group.get([this.inputParams.name]).push(formGroup);
            });
        }
        else {
            this.group.controls[this.inputParams.name].clear();
            (_b = this.refDataArr) === null || _b === void 0 ? void 0 : _b.forEach((x, index) => {
                const formGroup = this.createArrayList(x);
                this.group.get([this.inputParams.name]).push(formGroup);
            });
        }
        if (this.savedValue) {
            const formArray = this.group.get(this.inputParams.name);
            formArray.controls.forEach((control, index) => {
                const savedItem = this.savedValue.find(item => item.name === control.value.name);
                if (savedItem) {
                    control.patchValue({ isChecked: savedItem.isChecked });
                }
            });
        }
        this.cdRef.detectChanges();
    }
    createArrayList(item) {
        return this.fb.group({
            code: item.code,
            description: item.description,
            group: item.group,
            id: item.id,
            name: item.name,
            otherCode: item.otherCode,
            isChecked: item.isChecked,
        });
    }
    createCustomArrayList(item) {
        return this.fb.group({
            name: item.name,
            isChecked: item.isChecked,
        });
    }
    get getCheckboxArray() {
        return this.group.get([this.inputParams.name]).controls;
    }
    toggleInputFields() {
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
        }
        else {
            this.group.enable();
        }
        this.cdRef.detectChanges();
    }
    requiredArrayValidator(control) {
        const checkboxes = control.controls;
        const isChecked = checkboxes.some((checkbox) => checkbox.controls['isChecked'].value);
        return isChecked ? null : { requiredArray: true };
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
CustomCheckboxComponent.ɵfac = function CustomCheckboxComponent_Factory(t) { return new (t || CustomCheckboxComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.ActivatedRoute), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService), i0.ɵɵdirectiveInject(CustomCheckboxService)); };
CustomCheckboxComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomCheckboxComponent, selectors: [["custom-checkbox"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", group: "group", groupElementProperty: "groupElementProperty", fileUploadConfigurations: "fileUploadConfigurations", inputData: "inputData" }, decls: 3, vars: 7, consts: [[1, "form-group", 3, "formGroup"], [4, "ngIf"], [3, "formArrayName"], [1, "row", 2, "display", "block"], [4, "ngFor", "ngForOf"], ["class", "error", 4, "ngIf"], [2, "display", "inline-block", 3, "formGroupName"], [1, "pl-2", "custom-checkbox"], ["name", "isChecked", 3, "label", "value", "formControl", "binary"], [1, "label-cls", "label-max-width", "common-bene-class-for-translation", 3, "for"], [1, "error"], [1, "row", 2, "display", "block", 3, "formArrayName"], ["class", "error-indicator", 4, "ngIf"], [1, "error-indicator"], [2, "display", "inline-block"], ["name", "x.value.name", 3, "binary", "value", "ngModel", "formControl", "ngModelChange"]], template: function CustomCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CustomCheckboxComponent_div_1_Template, 6, 3, "div", 1);
        i0.ɵɵtemplate(2, CustomCheckboxComponent_div_2_Template, 5, 4, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(5, _c0, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.refDataArr && ctx.refDataArr.length > 0 && !(ctx.inputParams.properties.inputArray && ctx.inputParams.properties.inputArray.length > 0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.refDataArr && ctx.refDataArr.length == 0 && (ctx.inputParams.properties.inputArray && ctx.inputParams.properties.inputArray.length > 0));
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i7.NgIf, i1$1.FormArrayName, i7.NgForOf, i1$1.FormGroupName, i8.Checkbox, i1$1.NgControlStatus, i1$1.FormControlDirective], styles: [".customFormCheck[_ngcontent-%COMP%]   .customCheckLabel[_ngcontent-%COMP%]{padding:10px}.customFormCheck[_ngcontent-%COMP%]   .customCheckInput[_ngcontent-%COMP%]{width:15px!important}.customFormCheck[_ngcontent-%COMP%]   .pi-pencil[_ngcontent-%COMP%]{float:right;padding:14px}.error[_ngcontent-%COMP%]{top:12px}.error[_ngcontent-%COMP%], .error-indicator[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px;position:relative}.error-indicator[_ngcontent-%COMP%]{bottom:30px;left:56px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'custom-checkbox',
                templateUrl: 'custom-checkbox.component.html',
                styleUrls: ['custom-checkbox.component.scss'],
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.ReferenceLibraryService }, { type: i3.Store }, { type: i0.ChangeDetectorRef }, { type: i4.ActivatedRoute }, { type: i5.AppServicesLibraryService }, { type: CustomCheckboxService }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], groupElementProperty: [{
            type: Input
        }], fileUploadConfigurations: [{
            type: Input
        }], inputData: [{
            type: Input
        }] }); })();

class CustomCheckboxModule {
}
CustomCheckboxModule.ɵfac = function CustomCheckboxModule_Factory(t) { return new (t || CustomCheckboxModule)(); };
CustomCheckboxModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomCheckboxModule });
CustomCheckboxModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomCheckboxModule, { declarations: [CustomCheckboxComponent], imports: [ReactiveFormsModule,
        PrimengLibraryModule], exports: [CustomCheckboxComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomCheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomCheckboxComponent],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [CustomCheckboxComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-checkbox
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomCheckboxComponent, CustomCheckboxModule, CustomCheckboxService };
//# sourceMappingURL=custom-checkbox.js.map
